module.exports = __webpack_public_path__ + "media/images/icons/gplus-3ad17b0797501b369f816b1688cbc76a.svg";